import {Component, OnDestroy, OnInit} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Registration} from "../../../../../../models/registration";
import {RegistrationServiceLocation} from "../../../../../../models/registration-service-location";
import {ServiceLocation} from "../../../../../../models/service-location";
import {LocationService} from "../../../../../../services/location-controller/location.service";
import {RegistrationServiceLocationControllerService} from "../../../../../../services/location-controller/registration-service-location-controller.service";
import {ServiceLocationControllerService} from "../../../../../../services/location-controller/service-location-controller.service";
import {Store} from "../../../../../../services/store.service";
import {TranslatedBaseError} from "../../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {
  DeterminantControllerService,
} from "../../../../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "service-location-list",
  templateUrl: "./service-location-list.component.html",
  providers: [],
  styles: [],
})
export class ServiceLocationListComponent extends TranslatedBaseError implements OnInit, OnDestroy {

  public registration: Registration;
  public serviceId: string;
  public registrationServiceLocationList: RegistrationServiceLocation[] = [];
  public registrationServiceLocation: RegistrationServiceLocation;
  public serviceLocation: ServiceLocation;
  public serviceLocations: ServiceLocation[];
  public showDeterminantBuilder: boolean = false;
  public topLayer = "list";
  public listToggle: boolean = false;
  public userFilter: any = {name: ""};
  public subscription: any;
  public determinantMapById: { [key: string]: string } = {};
  constructor(private serviceLocationControllerService: ServiceLocationControllerService,
              private registrationServiceLocationControllerService: RegistrationServiceLocationControllerService,
              public locationService: LocationService,
              public determinantService: DeterminantControllerService,
              public store: Store,
              public toastr: ToastrService, public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    if (!this.determinantMapById) {
      this.determinantService.getServiceDeterminantIdAndName(this.store.state.common.serviceId).subscribe((determinants) => {
        Object.assign(this.determinantMapById, determinants);
      });
    }
    this.subscription = this.locationService.change.subscribe((data) => {
      this.registration = data.registration;
      this.serviceId = data.serviceId;
      this.registrationServiceLocationList = data.registrationServiceLocationList;
      this.serviceLocations = data.serviceLocations;
      this.showDeterminantBuilder = data.showDeterminantBuilder;
      this.registrationServiceLocation = data.registrationServiceLocationId;
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public saveRegistrationServiceLocation(serviceLocation) {
    if (this.registration !== undefined) {

      this.serviceLocation = serviceLocation;
      this.registrationServiceLocation = new RegistrationServiceLocation();
      this.registrationServiceLocation.serviceLocationId = this.serviceLocation.id;

      this.registrationServiceLocationControllerService.createServiceLocation(this.registration.id, this.registrationServiceLocation).subscribe(
        (data) => {
          this.locationService.updateData();
          this.responseSuccessful("Location added to registration");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public updateRegistrationServiceLocation(registrationServiceLocation) {
    registrationServiceLocation.registrationId = this.registration.id;
    this.registrationServiceLocationControllerService.saveRegistrationServiceLocation(registrationServiceLocation).subscribe(
      (data) => this.responseSuccessful("Location Registration updated"),
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
    );
  }

  public deleteRegistrationServiceLocation(serviceLocation) {
    let registrationServiceLocation;
    if (this.registrationServiceLocationList && this.registrationServiceLocationList.length > 0) {
       this.registrationServiceLocationList.forEach((thisServiceLocation: any) => {
         if (thisServiceLocation.serviceLocationId === serviceLocation.id) {
             registrationServiceLocation = thisServiceLocation;
         }
       });
    }
    this.registrationServiceLocationControllerService.deleteRegistrationServiceLocation(registrationServiceLocation.id).subscribe(
      (data) => {
        this.locationService.updateData();
        this.responseSuccessful("Location removed from registration");
      },
    );
  }

  public deleteServiceLocation(isConfirmed, serviceLocation) {
    if (isConfirmed) {
      this.serviceLocationControllerService.deleteServiceLocation(serviceLocation.id).subscribe(
        (data) => {
          this.locationService.updateData();
          this.responseSuccessful("Location deleted");
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public openEdit(serviceLocation: any) {
    if (serviceLocation) {
      this.serviceLocation = serviceLocation;
      this.registrationServiceLocation = new RegistrationServiceLocation();
      if (this.registrationServiceLocationList && this.registrationServiceLocationList.length > 0) {
         this.registrationServiceLocationList.forEach((thisServiceLocation: any) => {
           if (thisServiceLocation.serviceLocationId === serviceLocation.id) {
             this.registrationServiceLocation = thisServiceLocation;
           }
         });
      }
    } else {
      this.serviceLocation = new ServiceLocation();
    }
    this.topLayer = "edit";
  }

  public closeLayer() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = undefined;
  }

  public submitEdit(event) {
    if (event.registrationServiceLocationId && event.registrationServiceLocationId.id) {
      this.updateRegistrationServiceLocation(event.registrationServiceLocationId);
    }
    this.locationService.updateData();
    this.topLayer = "list";
  }

  public cancelEdit(event) {
    if (event.cancel) {
      this.topLayer = "list";
    }
  }
public ˇ;
  public isActive(serviceLocation) {
    let serviceLocationActive = false;
    if (this.registrationServiceLocationList && this.registrationServiceLocationList.length > 0) {
       this.registrationServiceLocationList.forEach((thisServiceLocation: any) => {
         if (thisServiceLocation.serviceLocationId === serviceLocation.id) {
           serviceLocationActive = true;
         }
       });
    }
    return serviceLocationActive;
  }

  public setListView(b) {
    this.listToggle = b;
  }

  public closeDetLayer() {
    this.store.state.common.determinantSection.reset();
  }

  appendDeterminant = (det) => {
    let data = JSON.parse(this.registrationServiceLocation.jsonDeterminants);
    if (!Array.isArray(data)) {
      data = [];
    }
    if (data.length === 0) {
      data.push({
        type: 'OR',
        items: []
      });
    }
    let lastItem = data[data.length - 1];
    if (lastItem.items == null) {
      lastItem = {
        type: 'OR',
        items: []
      };
      data.push(lastItem);
    }
    lastItem.items.push({
      type: det.type || 'OR',
      determinantId: det.determinantId,
    });
    this.registrationServiceLocation.jsonDeterminants = JSON.stringify(data);
  };
}
